import React , { Component } from 'react';
import {browserHistory,Link} from 'react-router';
import { Modal, Button ,Breadcrumb,Item} from 'react-bootstrap';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebNotifications extends Component{
	constructor(props){
		super(props);
		this.state={
			notifications: [],
			empty_status:false,
			deleteAll_modal:false,
		}
		this.deleteAll=this.deleteAll.bind(this);
		this.clearNotif=this.clearNotif.bind(this);
		// this.deleteModal=this.deleteModal.bind(this);
		this.getpnotifications =this.getpnotifications.bind(this);
		this.close=this.close.bind(this);
	}
	componentDidMount()
	{
		localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
		if(screen.width < 800)
		{
			window.location.href="/notifications";
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('notifications','/web/notifications');
			browserHistory.push('/web/login');
		}
		else
		{
			 this.getpnotifications();
		}
	} 
    getpnotifications()
	{
        var data1={id:localStorage.user_id,token:localStorage.token,from:'desktop_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'getpnotifications',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					if(data.notifications.length > 0)
					{
						this.setState({
							notifications: data.notifications,
						});	
					}
					else
					{
						this.setState({
							empty_status:true,
						});
					}
				}
				else if(data.status==='error' && data.message==='Token mismatch')
				{
					localStorage.clear();
					localStorage.setItem('notifications','/web/notifications');
					browserHistory.push('/web/login');
				}
				
			}.bind(this),
			error:function(err)
			{
				
			}
		});
	}		
	close()
	{
		this.setState({
			deleteAll_modal:false,
		});
	}
	// deleteModal()
	// {

	// 	this.setState({
	// 		deleteAll_modal:true,
	// 	});
	// }
	deleteAll()
	{
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'deleteAllNotifications',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						empty_status:true,
						deleteAll_modal:false,
					});
				}
				
			}.bind(this),
			error:function(err)
			{
				
			}
		});
	}
	// clearNotif(id,token,push_id,from)
	clearNotif(push_id)
	{
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,push_id:push_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'clearNotif',
			data:{req:data2},
			success:function(data)
			{
			   if(data.status === 'success')
			   {	
				 this.getpnotifications();
			   }
			}.bind(this),
			error:function(err)
			{
				
			}
		})
	}
	
	render(){
		document.title="Notifications | AquaDeals";
		var notifications = this.state.notifications.map(function(data,index){
			return(
				<div className="webNotificationItem">
					{data.link==='internal' ? 
					<div className="panel panel-default">
					  <div className="panel-body">
              	        <div className="row">
              	          <Link  onClick={()=>this.clearNotif(data.id)} to={data.url ? data.url : '/web/home'} style={{cursor:'pointer'}}>
						    <div className="col-lg-6 col-md-6 col-sm-6">
							  {data.title ? <h5 className="web_noty_title">{data.title}</h5> : <h5 className="web_noty_title">&nbsp;</h5>}
							  {data.content ? <h5 className="web_noty_content">{data.content}</h5> : <h5 className="web_noty_content">&nbsp;</h5>}
							</div>
							<div className="col-lg-5 col-md-5 col-sm-5 text-right"> 
							 {data.date ? <span className="web_noty_date">{data.date}</span> : <span className="web_noty_date">&nbsp;</span>}
						    </div>
						 </Link>
						 <div className="col-lg-1 col-md-1 col-sm-1 text-right">
						 	<i onClick={()=>this.clearNotif(data.id)}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} alt="remove" width="16px" /></i>
						 </div>
					   </div>	 
				      </div>	
                    </div>
					: 
                    <div className="panel panel-default">
					  <div className="panel-body">
						<div className="row">
						  <a  onClick={()=>this.clearNotif(data.id)} href={data.url ? data.url : '/web/home'} target="_blank" style={{cursor:'pointer'}}>
						    <div className="col-lg-6 col-md-6 col-sm-6">	
							  {data.title ? <h5 className="web_noty_title">{data.title}</h5> : <h5 className="web_noty_title">&nbsp;</h5>}
							  {data.content ? <h5 className="web_noty_content">{data.content}</h5> : <h5 className="web_noty_content">&nbsp;</h5>}
							</div>
							<div className="col-lg-5 col-md-5 col-sm-5 text-right">
						 	  {data.date ? <span className="web_noty_date">{data.date}</span> : <span className="web_noty_date ">&nbsp;</span>}
						    </div>
						  </a>
						  <div className="col-lg-1 col-md-1 col-sm-1 text-right">
                           <i onClick={()=>this.clearNotif(data.id)}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} alt="remove" width="16px" /></i>
						</div>
					   </div>	
				      </div>
				    </div>
				    }
				 </div>     
			)
		}.bind(this))
		return(
			<div className="web_deals web_notifications_page">
				<WebHeaderInner /> 
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className='container'>
				  <Breadcrumb>
			       <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
			       <Breadcrumb.Item active>Notifications</Breadcrumb.Item>
		          </Breadcrumb>
				</div>
				<section className="container">
					<div className="row">
						<div className="col-lg-12 col-md-12 col-sm-12  webDels_cntnt">
							<div className="container-fluid" style={{marginTop:'25px'}}>
							   <div className="row">
								  <div className="col-lg-8 col-md-8 col-sm-8">
                                    &nbsp;
								  </div>
								  <div className="col-lg-4 col-md-4 col-sm-4">
								    {!this.state.empty_status ? <a className="webNoty_emptybtn" onClick={()=>{this.setState({deleteAll_modal:true})}}><i><img alt="" src={baseAssets+'icons/web_icons/del_bin3.png'} width="20px" /></i><span>Delete all</span></a> : ''}
							      </div>
							   </div>
							</div>
						    <hr />
							<section className="container-fluid webNoty_blk_cnt">
							  {this.state.empty_status ? <div className="webNoty_empty">No Notifications Available</div> : notifications}
							</section>
							<Modal show={this.state.deleteAll_modal} onHide={this.close}  >
								<Modal.Header closeButton>
							    	<Modal.Title>Alert</Modal.Title>
							  	</Modal.Header>
								<Modal.Body>
							  		<h4>Do you want to remove all notifications? </h4>
							  	</Modal.Body>
							  	<Modal.Footer className="webCart_confirm">
						  			<Button onClick={this.close}>NO</Button>
						  			<a><Button onClick={()=>{this.deleteAll()}}>YES</Button></a>
							  	</Modal.Footer>
							</Modal>
						</div>
					</div>
				</section>
				 <WebFooter /> 
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Accounts/Web_Notifications.js
 **/